'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var leftPath = ['M-14-10h40v40h-40z', 'M12.32 2.333L9.99 0 0 10l9.99 10 2.33-2.333L4.662 10z'];

exports["default"] = leftPath;
